import { API_URL } from './api';

let _promise = null;
let _clientId = null;

export function getGoogleClientId() {
  return _clientId;
}

export function prefetchGoogleClientId() {
  if (!_promise) {
    _promise = fetch(`${API_URL}/config/google-client-id`)
      .then(r => r.json())
      .then(data => { _clientId = data.client_id || null; return _clientId; })
      .catch(() => { _clientId = null; return null; });
  }
  return _promise;
}
